const state = () => ({
  patients: null,
  patientsTotalCount: null,
  deleted: null,
  all: null,
})
const getters = {
  patients: (state) => state.patients,
  patientsTotalCount: (state) => state.patientsTotalCount,
  deleted: (state) => state.deleted,
  all: (state) => state.all,
}
const mutations = {
  receivePatients(state, patients) {
    state.patients = patients
  },
  appendPatients(state, patients) {
    const base = state.patients || []
    const seen = new Set(base.map((p) => p.id))
    const additions = patients.filter((p) => {
      if (seen.has(p.id)) {
        return false
      }
      seen.add(p.id)
      return true
    })
    state.patients = [...base, ...additions]
  },
  setPatientsTotalCount(state, count) {
    state.patientsTotalCount = count
  },
  receiveDeleted(state, patients) {
    state.deleted = patients
  },
  receiveAll(state, patients) {
    state.all = patients
  },
}
const actions = {
  getPatients({ commit, state, rootState }, payload) {
    const groupId = payload.groupId
    const offset = payload.offset != null ? payload.offset : 0
    const limit = payload.limit != null ? payload.limit : 27
    return this.$axios
      .post('/bodygram-backend/v1/core/patients/list', {
        accessToken: rootState.user.token,
        filters: {
          query: null,
          groupId,
        },
        offset,
        limit,
      })
      .then((response) => {
        // Remote API returns `count` and honours offset/limit. Electron (offline) backends
        // older than the version that adds `count` omit it but return the full patient list
        // in a single response. Without a synthetic total, the UI would keep paginating and
        // hit the local API repeatedly; when `count` is missing we treat the payload as the
        // complete set for this group and set `patientsTotalCount` from list length.
        const newPatients = response.data.patients || []
        const countFromApi =
          response.data.count != null ? response.data.count : null
        const baseBefore = state.patients || []
        const baseLength = baseBefore.length

        if (offset > 0 && newPatients.length === 0) {
          commit('setPatientsTotalCount', baseLength)
          return
        }

        if (offset === 0) {
          commit('setPatientsTotalCount', null)
          commit('receivePatients', newPatients)
        } else {
          commit('appendPatients', newPatients)
        }

        if (countFromApi != null) {
          commit('setPatientsTotalCount', countFromApi)
          return
        }

        // Electron retrocompatibility: no `count` — derive total so infinite scroll stops.
        if (offset === 0) {
          commit('setPatientsTotalCount', newPatients.length)
        } else {
          commit('setPatientsTotalCount', (state.patients || []).length)
        }
      })
  },
  searchPatients({ commit, rootState }, query) {
    return this.$axios
      .post('/bodygram-backend/v1/core/patients/list', {
        accessToken: rootState.user.token,
        filters: {
          query,
        },
        offset: 0,
      })
      .then((response) => {
        commit('receivePatients', response.data.patients)
      })
  },
  getAll({ commit, rootState }) {
    return this.$axios
      .post('/bodygram-backend/v1/core/patients/list', {
        accessToken: rootState.user.token,
      })
      .then((response) => {
        commit('receiveAll', response.data.patients)
      })
  },
  getDeleted({ commit, rootState }, groupId) {
    return this.$axios
      .post('/bodygram-backend/v1/core/patients/list', {
        accessToken: rootState.user.token,
        filters: {
          query: null,
          groupId,
          deleted: true,
        },
        offset: 0,
      })
      .then((response) => {
        commit('receiveDeleted', response.data.patients)
      })
  },
  restorePatient({ dispatch, rootState, rootGetters }, patientId) {
    return this.$axios
      .post('/bodygram-backend/v1/core/patients/restore', {
        accessToken: rootState.user.token,
        id: patientId,
      })
      .then(() => {
        if (
          window.$nuxt.$platform === 'electron' &&
          rootGetters['network/onLine']
        ) {
          this.$axios.post(
            `${rootGetters['network/localAPI']}/bodygram-backend/v1/core/patients/restore`,
            {
              silent: true,
              id: patientId,
            }
          )
        }
      })
  },
  permanentDeletePatient(
    { dispatch, rootState, rootGetters },
    { groupId, patientId }
  ) {
    return this.$axios
      .post('/bodygram-backend/v1/core/patients/delete', {
        accessToken: rootState.user.token,
        id: patientId,
        permanent: true,
      })
      .then(() => {
        if (
          window.$nuxt.$platform === 'electron' &&
          rootGetters['network/onLine']
        ) {
          this.$axios.post(
            `${rootGetters['network/localAPI']}/bodygram-backend/v1/core/patients/delete`,
            {
              silent: true,
              id: patientId,
              permanent: true,
            }
          )
        }
      })
  },
}
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
